'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _year_dropdown = require('./year_dropdown');

var _year_dropdown2 = _interopRequireDefault(_year_dropdown);

var _month = require('./month');

var _month2 = _interopRequireDefault(_month);

var _ChevronLeft = require('../../components/Svg/ChevronLeft');

var _ChevronLeft2 = _interopRequireDefault(_ChevronLeft);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _date_utils = require('./date_utils');

var _constants = require('../../shared/constants');

var _Time = require('@wix/wixrest-utils/dist/Time');

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = function (_React$Component) {
    _inherits(Calendar, _React$Component);

    function Calendar(props, context) {
        _classCallCheck(this, Calendar);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        _initialiseProps.call(_this);

        var selected = props.selected,
            minDate = props.minDate,
            includeDates = props.includeDates,
            excludeDates = props.excludeDates,
            timezone = props.timezone;

        var firstDate = (0, _date_utils.getEffectiveMinDate)({ minDate: minDate, includeDates: includeDates, excludeDates: excludeDates });
        var hovered = selected ? selected.isBefore(firstDate) ? firstDate : selected : firstDate || _moment2.default.tz(new Date(), timezone);

        _this.state = {
            hovered: hovered,
            date: _this.localizeMoment(_this.getDateInView())
        };
        return _this;
    }

    Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.selected && !(0, _date_utils.isSameDay)(nextProps.selected, this.props.selected)) {
            this.setState({
                date: this.localizeMoment(nextProps.selected)
            });
        }
        if (nextProps.minDate && !(0, _date_utils.isSameDay)(nextProps.minDate, this.props.minDate)) {
            var firstDate = (0, _date_utils.getEffectiveMinDate)({ minDate: nextProps.minDate, includeDates: nextProps.includeDates, excludeDates: nextProps.excludeDates });
            var hovered = nextProps.selected ? nextProps.selected.isBefore(firstDate) ? firstDate : nextProps.selected : firstDate || _moment2.default.tz(new Date(), nextProps.timezone);
            var newState = { hovered: hovered };

            if (!nextProps.selected || nextProps.selected.isBefore(firstDate)) {
                newState.date = this.localizeMoment(this.getDateInView(nextProps));
            }

            this.setState(newState);
        }
    };

    Calendar.prototype.render = function render() {
        var _this2 = this;

        var hovered = this.state.hovered;

        var selected = this._getSelectedDate();
        return _react2.default.createElement(
            'div',
            { className: 'wix-dropdown-datepicker', role: 'dialog', 'aria-modal': 'true' },
            _react2.default.createElement('div', { className: 'wix-dropdown-datepicker__triangle' }),
            _react2.default.createElement(
                'div',
                { className: 'wix-dropdown-datepicker__header' },
                _react2.default.createElement(
                    'div',
                    { className: 'wix-dropdown-datepicker__inner-header', 'aria-hidden': 'true' },
                    this.renderPreviousMonthButton(),
                    this.renderCurrentMonth(),
                    this.renderYearDropdown(),
                    this.renderNextMonthButton()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'wix-dropdown-datepicker__header-days', 'aria-hidden': 'true' },
                    this.header()
                )
            ),
            _react2.default.createElement(_month2.default, { ref: function ref(el) {
                    return _this2.month = el;
                },
                onTab: this._onMonthTabButton,
                ariaLabelledBy: 'site-react-dropdown-' + this.props.id + '_year-label',
                locale: this.props.locale,
                timezone: this.props.timezone,
                day: this.state.date,
                onDayClick: this.handleDayClick,
                minDate: this.props.minDate,
                maxDate: this.props.maxDate,
                onlyMonthDays: this.props.onlyMonthDays,
                excludeDates: this.props.excludeDates,
                includeDates: this.props.includeDates,
                filterDate: this.props.filterDate,
                selected: selected,
                startDate: this.props.startDate,
                hovered: this.state.hovered,
                setHover: this._onSetHover,
                endDate: this.props.endDate }),
            this.renderTodayButton()
        );
    };

    return Calendar;
}(_react2.default.Component);

Calendar.displayName = 'Calendar';
Calendar.defaultProps = {
    locale: typeof window !== 'undefined' ? window.__NORMALIZED_APP_LOCALE__ : 'en',
    timezone: '',
    excludeDates: {}
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.getDateInView = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
        var selected = props.selected,
            min = props.minDate,
            max = props.maxDate,
            includeDates = props.includeDates,
            excludeDates = props.excludeDates,
            timezone = props.timezone;

        var maxDate = (0, _date_utils.getEffectiveMaxDate)({ maxDate: max, includeDates: includeDates });
        var minDate = (0, _date_utils.getEffectiveMinDate)({ minDate: min, includeDates: includeDates, excludeDates: excludeDates });
        var current = _moment2.default.tz(new Date(), timezone);
        minDate = _moment2.default.max(minDate, current);

        if (selected) {
            current = minDate && selected.isBefore(minDate) ? minDate : selected;
        } else if (minDate && minDate.isAfter(current)) {
            current = minDate;
        } else if (maxDate && maxDate.isBefore(current)) {
            current = maxDate;
        }
        var counter = 365;

        while (excludeDates[_Time2.default.serializeDate(current)] && (maxDate ? maxDate.isAfter(current) : true) && counter > 0) {
            current = current.add(1, 'days');
            counter = counter - 1;
        }

        return current;
    };

    this.localizeMoment = function (date) {
        return date.clone().locale(_this3.props.locale);
    };

    this.increaseMonth = function (e) {
        var _props = _this3.props,
            includeDates = _props.includeDates,
            excludeDates = _props.excludeDates;

        var nextMonth = _this3.state.date.clone().add(1, 'month');
        _this3.setState({
            date: nextMonth,
            hovered: (0, _date_utils.getEffectiveMinDate)({ minDate: nextMonth.clone().startOf('month'), includeDates: includeDates, excludeDates: excludeDates })
        });
        if (e) {
            e.preventDefault();
        }
    };

    this.decreaseMonth = function (e) {
        var _props2 = _this3.props,
            includeDates = _props2.includeDates,
            excludeDates = _props2.excludeDates,
            minDate = _props2.minDate;

        var prevMonth = _this3.state.date.clone().subtract(1, 'month');
        var prevMonthStart = prevMonth.clone().startOf('month');
        var min = prevMonthStart.isBefore(minDate) ? minDate : prevMonthStart;
        _this3.setState({
            date: prevMonth,
            hovered: (0, _date_utils.getEffectiveMinDate)({ minDate: min, includeDates: includeDates, excludeDates: excludeDates })
        });
        if (e) {
            e.preventDefault();
        }
    };

    this.handleDayClick = function (day) {
        _this3.props.onSelect(day);
    };

    this.changeYear = function (year) {
        _this3.setState({
            date: _this3.state.date.clone().set('year', year)
        });
    };

    this.header = function () {
        var locale = _this3.props.locale;

        var startOfWeek = _this3.state.date.clone().startOf('week');
        return [0, 1, 2, 3, 4, 5, 6].map(function (offset) {
            var day = startOfWeek.clone().add(offset, 'days').locale(locale);
            return _react2.default.createElement(
                'div',
                { key: offset, className: 'wix-dropdown-datepicker__day-name' },
                day.localeData().weekdaysMin(day)[0]
            );
        });
    };

    this.renderPreviousMonthButton = function () {
        var _classNames;

        var date = _this3.state.date;
        var locale = _this3.props.locale;

        var disabled = (0, _date_utils.allDaysDisabledBefore)(date, 'month', _this3.props);
        var classes = (0, _classnames2.default)('wix-dropdown-datepicker__navigation wix-dropdown-datepicker__navigation--previous', (_classNames = {}, _classNames[_constants.CLASSES.DATE_PICKER_CHEVRON] = true, _classNames[_constants.CLASSES.DATE_PICKER_CHEVRON_DISABLED] = disabled, _classNames.disabled = disabled, _classNames));
        var onClickHandler = disabled ? function (e) {
            return e.preventDefault();
        } : _this3.decreaseMonth;
        var prevMonth = date.clone().locale(locale).subtract(1, 'month');

        return _react2.default.createElement(
            'a',
            { ref: function ref(el) {
                    return _this3.prevButton = el;
                },
                href: '',
                tabIndex: '0',
                className: classes,
                onKeyDown: function onKeyDown(e) {
                    return _this3._onNavKeyDown(e, -1, disabled);
                },
                onClick: onClickHandler,
                role: 'button',
                'aria-disabled': disabled,
                'aria-label': prevMonth.format('MMMM YYYY') },
            _react2.default.createElement(_ChevronLeft2.default, { height: 11, width: 6 })
        );
    };

    this.renderNextMonthButton = function () {
        var _classNames2;

        var date = _this3.state.date;
        var locale = _this3.props.locale;

        var disabled = (0, _date_utils.allDaysDisabledAfter)(date, 'month', _this3.props);
        var classes = (0, _classnames2.default)('wix-dropdown-datepicker__navigation wix-dropdown-datepicker__navigation--next', (_classNames2 = {}, _classNames2[_constants.CLASSES.DATE_PICKER_CHEVRON] = true, _classNames2[_constants.CLASSES.DATE_PICKER_CHEVRON_DISABLED] = disabled, _classNames2.disabled = disabled, _classNames2));
        var onClickHandler = disabled ? function (e) {
            return e.preventDefault();
        } : _this3.increaseMonth;
        var nextMonth = date.clone().locale(locale).add(1, 'month');

        return _react2.default.createElement(
            'a',
            { ref: function ref(el) {
                    return _this3.nextButton = el;
                },
                href: '',
                tabIndex: '0',
                className: classes,
                onKeyDown: function onKeyDown(e) {
                    return _this3._onNavKeyDown(e, 1, disabled);
                },
                onClick: onClickHandler,
                role: 'button',
                'aria-disabled': disabled,
                'aria-label': nextMonth.format('MMMM YYYY') },
            _react2.default.createElement(_ChevronLeft2.default, { height: 11, width: 6, rotate: 180 })
        );
    };

    this._onNavKeyDown = function (e, dir, disabled) {
        var key = e.keyCode || e.which;

        switch (key) {
            case _constants.KEY_CODES.TAB:
                if (dir < 0 && e.shiftKey) {
                    _this3._focusMonth();
                    e.preventDefault();
                }
                break;
            case _constants.KEY_CODES.ENTER:
            case _constants.KEY_CODES.SPACE:
                if (!disabled) {
                    if (dir > 0) {
                        _this3.increaseMonth(e);
                    } else {
                        _this3.decreaseMonth(e);
                    }
                    e.preventDefault();
                }
                break;
        }
    };

    this.renderCurrentMonth = function () {
        var locale = _this3.props.locale;

        var classes = ['wix-dropdown-datepicker__current-month'];
        if (_this3.props.showYearDropdown) {
            classes.push('wix-dropdown-datepicker__current-month--hasYearDropdown');
        }

        return _react2.default.createElement(
            'div',
            { className: classes.join(' '), id: 'site-react-dropdown-' + _this3.props.id + '_year-label' },
            _this3.state.date.locale(locale).format(_this3.props.dateFormat)
        );
    };

    this.renderYearDropdown = function () {
        if (!_this3.props.showYearDropdown) {
            return;
        }
        return _react2.default.createElement(_year_dropdown2.default, {
            onChange: _this3.changeYear,
            year: _this3.state.date.year() });
    };

    this.renderTodayButton = function () {
        if (!_this3.props.todayButton) {
            return;
        }
        return _react2.default.createElement(
            'div',
            { className: 'wix-dropdown-datepicker__today-button', onClick: function onClick() {
                    return _this3.props.onSelect(_moment2.default.tz(new Date(), _this3.props.timezone));
                } },
            _this3.props.todayButton
        );
    };

    this._onSetHover = function (hovered) {
        var monthAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var date = _this3.state.date;

        var newState = { hovered: hovered };
        if (!hovered.isSame(date, 'month')) {
            var newDate = null;

            if (monthAction === 'before') {
                newDate = date.clone().subtract(1, 'month');
            } else if (monthAction === 'after') {
                newDate = date.clone().add(1, 'month');
            }

            if (newDate) {
                newState.date = newDate;
            }
        }

        _this3.setState(newState);
    };

    this._getSelectedDate = function () {
        var _props3 = _this3.props,
            selected = _props3.selected,
            minDate = _props3.minDate;

        var selectedDate = undefined;

        if (selected && (!minDate || !selected.isBefore(minDate))) {
            selectedDate = selected;
        }

        return selectedDate;
    };

    this._onMonthTabButton = function (e) {
        if (!e.shiftKey) {
            _this3._focusPrevButton();
        } else {
            _this3._focusNextButton();
        }
        e.preventDefault();
    };

    this._focusNextButton = function () {
        _this3.nextButton.focus();
    };

    this._focusPrevButton = function () {
        _this3.prevButton.focus();
    };

    this._focusMonth = function () {
        _this3.month.focus();
    };
};

module.exports = Calendar;